export default __webpack_public_path__ + "static/media/app-logo-dark.4eed2217.svg";